import type { schemaType as StrapiEscapadasDetailSchemaType } from '~~/shared/api/strapi/escapadas/detail/schema'
import type { schemaType as StrapiCottagesPagechemaType } from '~~/shared/api/strapi/cottages-page/schema'
import type { schemaType as StrapiBrandingCampaignType } from '~~/shared/api/strapi/branding-campaign/schema'
import type { schemaType as DestinosSchemaType } from '~~/shared/api/strapi/destinos/detail/schema'
import type {
  propsInterface,
  itemInterface,
} from '~~/modules/design-system/sections/s-cards-images/s-cards-images-wrapper.vue'

export const useToSCardsImagesWrapper = () => {
  const fromStrapiEscapadasDetail = (
    data: StrapiEscapadasDetailSchemaType,
  ): propsInterface => {
    let items: propsInterface['items'] = []

    if (data.attributes.featured_destinations?.length) {
      items = data.attributes.featured_destinations.map(item => {
        const cards: itemInterface['cards'] = item.card.map(aCard => {
          return {
            url: aCard.url,
            image: aCard.image.data[0].attributes.url,
            title: aCard.title,
          }
        })

        const returnObject: itemInterface = {
          cards,
          title: item.title || undefined,
        }
        return returnObject
      })
    }

    return { items }
  }

  const fromStrapiCottagesPage = (
    data: StrapiCottagesPagechemaType,
  ): propsInterface => {
    let items: propsInterface['items'] = []

    if (data.attributes.featured_destinations?.length) {
      items = data.attributes.featured_destinations.map(item => {
        const cards: itemInterface['cards'] = item.card.map(aCard => {
          return {
            url: aCard.url,
            image: aCard.image.data[0].attributes.url,
            title: aCard.title,
          }
        })

        const returnObject: itemInterface = {
          cards,
          title: item.title || undefined,
        }
        return returnObject
      })
    }

    return { items }
  }

  const fromStrapiBrandingCampaign = (
    data: StrapiBrandingCampaignType,
  ): propsInterface => {
    let items: propsInterface['items'] = []

    if (data.attributes.featured_destinations?.length) {
      items = data.attributes.featured_destinations.map(item => {
        const cards: itemInterface['cards'] = item.card.map(aCard => {
          return {
            url: aCard.url,
            image: aCard.image.data[0].attributes.url,
            title: aCard.title,
          }
        })

        const returnObject: itemInterface = {
          cards,
          title: item.title || undefined,
          button: item.button,
        }
        return returnObject
      })
    }

    return { items }
  }

  const fromStrapiDestinosDetail = (
    data: DestinosSchemaType,
  ): propsInterface => {
    let items: propsInterface['items'] = []

    if (data.attributes.featured_destinations?.length) {
      items = data.attributes.featured_destinations.map(item => {
        const cards: itemInterface['cards'] = item.card.map(aCard => ({
          url: aCard.url,
          image: aCard.image.data[0]?.attributes.url || '',
          title: aCard.title,
        }))
        const returnObject: itemInterface = {
          cards,
          title: item.title || undefined,
        }
        return returnObject
      })
    }
    return { items }
  }

  return {
    fromStrapiEscapadasDetail,
    fromStrapiCottagesPage,
    fromStrapiBrandingCampaign,
    fromStrapiDestinosDetail,
  }
}
